<mat-toolbar class="editing-toolbar">
    <span>Users of <i>{{currentGroup?.name}}</i></span>

    <span class="spacer"></span>

    <!-- TODO: Allow deleting a section -->
    <button mat-raised-button class="tools-button" (click)="saveForm()" [disabled]="saveButtonDisabled">
      <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
      <span>Save</span>
    </button>
</mat-toolbar>

<div>
  <form [formGroup]="roleForm" class="dataset-form">

    <mat-form-field>
      <mat-label>User</mat-label>
      <mat-select formControlName="userid">
        <mat-option *ngFor="let user of potentialGroupUsers" [value]="user.id">
          {{ user.login | titlecase }}
        </mat-option>
      </mat-select>
      <mat-error>{{ getErrorMessage(useridControl) }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>User role</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let role of potentialGroupRoles" [value]="role">
          {{ role | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>

<div class="table-container">
  <table role="grid" class="mat-elevation-z8 mood-table">
    <thead>
      <tr>
        <th>Login</th>
        <th>Email</th>
        <th>Name</th>
        <th>role</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of groupUsersList">
        <td>{{ user.login }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.firstname ? user.firstname : '' + ' ' + user.surname ? user.surname : '' }} </td>
        <td>{{ user.role | titlecase }}</td>
        <td>
          <button mat-icon-button (click)="removeUser(user)" *ngIf="currentUserId != user.id">
            <mat-icon svgIcon="delete-circle"></mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

